import React from 'react';
import { Edit, SimpleForm, TextInput, email, required, SelectArrayInput } from 'react-admin';

export const UserEdit = (props) => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput source="name" label="Name" />
            <TextInput source="position" label="Position" />
            <TextInput source="email" label="E-mail" validate={ [required(), email()] } />
            <TextInput source="phone_number" label="Phone" />
            <TextInput source="plainPassword" type="password" label="New password (keep empty te keep existing one)" />
            <SelectArrayInput source="roles" label="Rollen" validate={ [required()]} choices={[
                { id: 'ROLE_ADMIN', name: 'Admin' },
                { id: 'ROLE_JOBOFFER', name: 'Job Offer Manager' },
                { id: 'ROLE_RTV', name: 'RTV Manager' },
                { id: 'ROLE_OOH', name: 'OOH Abri Manager' },
                { id: 'ROLE_CONSENT', name: 'Cookie Consent Manager' },
            ]} />

        </SimpleForm>
    </Edit>
);